// extracted by mini-css-extract-plugin
export default {"description":"hcx-profile_description__UsKz7","dashedRow":"hcx-profile_dashedRow__65lSg","textColor":"hcx-profile_textColor__KNZp7"};